import { faCheckDouble, faTrashAlt, faCheck } from '@fortawesome/pro-light-svg-icons/index';

export const STEPS = {
  STEP_SELECT: 0,
  STEP_CONFIRM: 1,
  STEP_COMPARE: 2,
  STEP_MAP_FROM_EXTERNAL_DATABASE: 3,
};

export const STEP_METADATA = {
  [STEPS.STEP_CONFIRM]: {
    title: 'Confirm Mapping',
    subtitle:
      'Compare the information filled in for the activity to existing data on file to see if it’s the right person.',
  },
  [STEPS.STEP_SELECT]: {
    title: 'Attribute Activity',
    subtitle:
      'The email address this person used is not on file. <br />  Connect this activity to a record on Almabase',
  },
  [STEPS.STEP_COMPARE]: {
    title: 'Update Data',
    subtitle:
      'This submission contains information that was not previously recorded for this person.<br /> Review this information and update their record accordingly. ',
  },
  [STEPS.STEP_MAP_FROM_EXTERNAL_DATABASE]: {
    title: `Map Constituent From ${window.isExternalDatabaseBBCRM ? 'BBCRM' : "Raiser's Edge"}`,
    subtitle: '',
  },
};

export const AppendCardConfig = {
  wrapperBorderProps: {
    borderStyle: '',
    bordered: false,
    borderColour: '',
  },
  detailsBorderProps: {
    borderStyle: 'dashed',
    bordered: true,
    borderColour: '#0044C1',
  },
  actionButtonProps: {
    text: 'Approve',
    icon: faCheckDouble,
    color: '#0044C1',
  },
  ignoreButtonProps: {
    text: 'Discard',
    icon: faTrashAlt,
    color: '',
  },
  completeStateButtonProps: {
    text: 'Added',
    icon: faCheck,
    color: '#36B37E',
  },
};

export const JUNE_EVENT_NAME = {
  alumniProfileListing: 'Clicked to edit user directory visibility',
};
